import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Users, ClipboardCheck, FileText } from 'lucide-react';

const EmployeeSidebar = () => {
  const location = useLocation();

  const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, path: '/employee' },
    { name: 'My Leads', icon: Users, path: '/employee/leads' },
    { name: 'Update Status', icon: ClipboardCheck, path: '/employee/update-status' },
    { name: 'Daily Report', icon: FileText, path: '/employee/daily-report' },
  ];

  return (
    <div className="w-64 bg-white dark:bg-slate-900 text-slate-800 dark:text-white border-r border-slate-200 dark:border-slate-800 flex flex-col h-screen transition-colors duration-200">
      <div className="p-6 border-b border-slate-200 dark:border-slate-800">
        <h2 className="text-2xl font-black bg-gradient-to-r from-[#10B981] to-teal-500 bg-clip-text text-transparent">
          ⚡ SolarPro
        </h2>
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-1 font-medium tracking-wide">
          Employee Portal
        </p>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-1.5 overflow-y-auto">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.name}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-semibold transition-all duration-200 ${
                isActive
                  ? 'bg-emerald-500/10 text-[#10B981] dark:bg-emerald-500/15 dark:text-emerald-400 border border-emerald-500/20'
                  : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-white'
              }`}
            >
              <item.icon size={19} />
              <span>{item.name}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-200 dark:border-slate-800 text-xs text-slate-400 dark:text-slate-500 font-medium">
        DevDeepam v1.0.0
      </div>
    </div>
  );
};

export default EmployeeSidebar;